import React from "react";
import { StyledFormElementsWrapper, ContainerGrid } from "../styles";
import CustomSelect from "./CustomSelect";
import FormField from "../../../common/FormField/FormField";
import styled from "styled-components";

const NoticeDesign = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  menuItems,
  getNoticeTemplates,
}) => {
  const inputs = [
    {
      type: "number",
      name: "lineSpacing",
      label: "Line Spacing",
      placeholder: "10",
    },
    {
      type: "number",
      name: "afterLineSpacing",
      label: "After Line Spacing",
      placeholder: "1",
    },
    {
      type: "number",
      name: "topMargin",
      label: "Top Margin",
      placeholder: "2.25",
    },
    {
      type: "number",
      name: "bottomMargin",
      label: "Bottom Margin",
      placeholder: "1.25",
    },
    {
      type: "number",
      name: "leftMargin",
      label: "Left Margin",
      placeholder: "1.5",
    },
    {
      type: "number",
      name: "rightMargin",
      label: "Right Margin",
      placeholder: "1.5",
    },
    {
      type: "number",
      name: "headerDistance",
      label: "Header Distance",
      placeholder: "0.25",
    },
    {
      type: "number",
      name: "footerDistance",
      label: "Footer Distance",
      placeholder: "0.25",
    },
    {
      type: "number",
      name: "fontSize",
      label: "Font Size",
      placeholder: "10",
    },
  ];

  return (
    <StyledFormElementsWrapper
      style={{ marginBottom: 8, marginTop: 15 }}
      width={"100%"}
    >
      <ContainerGrid>
        <CustomSelect
          name="partyId"
          trigger={true}
          {...{
            errors,
            touched,
            setFieldValue,
            menuItems,
            getNoticeTemplates,
          }}
        />
      </ContainerGrid>
      <Grid className="input-text">
        {inputs.map((input, index) => {
          return (
            <FormField
              key={index}
              {...{
                touched,
                errors,
                input,
                values,
                handleChange,
                handleBlur,
                setFieldValue,
              }}
            />
          );
        })}
      </Grid>
    </StyledFormElementsWrapper>
  );
};

export default NoticeDesign;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
`;
